import { render, staticRenderFns } from "./ModalIndex.vue?vue&type=template&id=31412128&"
import script from "./ModalIndex.vue?vue&type=script&lang=js&"
export * from "./ModalIndex.vue?vue&type=script&lang=js&"
import style0 from "./ModalIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports